<div *ngFor="let legend of legendItems" class="legend">
  <div class="legend-item-color"
       [style.background]="legend.iconColor"></div>
  <div class="legend-title">{{ legend.title }}</div>
</div>
